module.exports = __webpack_public_path__ + "static/media/Puan.8dc82475.svg";